import { ReactNode } from 'react';

import pluralize from 'pluralize';

import {
  Icons,
  mergeSx,
  HexIcon,
  HexIconProps,
  Placeholder,
  PlaceholderProps,
  tokens,
} from '@cast/design-system';

import { useSearchContext } from './hooks';

type NoResultsProps = Omit<PlaceholderProps, 'title'> & {
  title?: ReactNode;
  entity?: string;
  hexProps?: HexIconProps;
};

export const NoResults = ({
  icon = <Icons.MagnifyingGlass />,
  entity = 'entry',
  hexProps,
  sx,
  ...rest
}: NoResultsProps) => {
  const searchContext = useSearchContext();

  return (
    <Placeholder
      icon={
        <HexIcon
          size={64}
          icon={icon}
          hexColor={tokens.theme.bg.status.neutralSubtle}
          iconColor={tokens.theme.fg.status.onNeutralSubtle}
          iconWeight="fill"
          {...hexProps}
        />
      }
      title="No results found"
      body={
        searchContext?.debouncedFreeText && !!entity
          ? `Unfortunately, we did not find any ${pluralize(
              entity,
              2
            )} matching “${searchContext.debouncedFreeText}”.`
          : 'Please adjust your filters and try again.'
      }
      sx={mergeSx(
        {
          marginTop: '32px',
        },
        sx
      )}
      testId="no-results-found"
      {...rest}
    />
  );
};
